export default __webpack_public_path__ + "static/media/partly_cloudy.bd05e8ee.svg";